import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { apiService } from '@/utils/api';
import { Site } from '@/types';

const VismaAuthentication: React.FC = () => {
  const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  // Get sites
  const { data: sites = [] } = useQuery<Site[]>(
    'sites',
    () => apiService.getSites()
  );

  // Auto-select first site
  useEffect(() => {
    if (sites.length > 0 && !selectedSiteId) {
      setSelectedSiteId(sites[0].id);
    }
  }, [sites, selectedSiteId]);

  const handleGetVismaAuthUrl = async () => {
    try {
      setError(null);
      const result = await apiService.getVismaAuthUrl();
      window.open(result.auth_url, '_blank');
    } catch (err) {
      setError('Failed to get Visma authentication URL');
      console.error('Error getting Visma auth URL:', err);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Visma Authentication</h1>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="bg-white shadow rounded-lg p-6">
        <form className="space-y-4">
          <div>
            <label htmlFor="site-select" className="block text-sm font-medium text-gray-700 mb-2">
              Site
            </label>
            <select
              id="site-select"
              value={selectedSiteId || ''}
              onChange={(e) => setSelectedSiteId(Number(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select a site</option>
              {sites.map((site) => (
                <option key={site.id} value={site.id}>
                  {site.url}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end pt-6">
            <button
              type="button"
              onClick={handleGetVismaAuthUrl}
              disabled={!selectedSiteId}
              className="text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 hover:opacity-90 focus:outline-none focus:ring-2 disabled:opacity-50"
              style={{ backgroundColor: 'hsl(15 100% 52%)' }}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VismaAuthentication;
